import { Controller } from "@hotwired/stimulus"
// import { useClickOutside, useIntersection, useTransition } from 'stimulus-use'
import { useTransition } from "stimulus-use"
import axios from "axios"
// import { IntersectionController } from 'stimulus-use'
// import { useTransition } from 'stimulus-use/dist/use-transition'

/* przykład użycia: app/views/design/uix/stimulus.html.erb */

export default class extends Controller {
  static targets = ["menu", "preview", "email", "li", "form", "option", "clock", "toggle", "hidden", "commit", "microsoftHint"]
  static values = { type: String }

  clockOffset = 0

  connect() {
    console.log("connect1 email")

    if (this.hasMenuTarget) {
      const hidden = this.menuTarget.classList.contains("hidden")
      useTransition(this, { element: this.menuTarget })

      if (!hidden || this.menuTarget.id === window.location.hash.split("#")[1] + "_content") {
        this.toggleLink()
      }
    }

    this.jumpToEmail()

    if (this.hasFormTarget) {
      this.formTarget.onkeypress = function (event) {
        const key = event.key
        if (key === "Enter") {
          event.preventDefault()
        }
      }
    }

    if (this.hasClockTarget) {
      this.clockOffset = parseInt(this.clockTarget.innerHTML) - new Date().getTime()
      this.startTime()
    }

    if (this.typeValue === "note") {
      this.setupNoColorCopyHandler()
    }
  }

  jumpToEmail() {
    if (this.hasLiTarget && this.liTarget.id === this.liTarget.dataset.anchorId) {
      this.liTarget.scrollIntoView(true)
    }
  }

  toggleLink() {
    const hidden = this.menuTarget.classList.contains("hidden")
    if (hidden) {
      this.toggle()
    }
  }

  toggleSmtp() {
    const select = document.getElementById("mailbox_smtp_kind")
    const value = select.value

    // Pokazywanie/ukrywanie pól SMTP - tylko dla "own"
    if ((value === "own") === this.menuTarget.classList.contains("hidden")) {
      this.toggle()
    }

    // Hint do Microsoft SMTP - pokazujemy tylko gdy wybrano "microsoft" a integracji jeszcze nie ma.
    // Gdy integracja juz istnieje, model po prostu podepnie connector przy save - bez hinta.
    if (this.hasMicrosoftHintTarget) {
      const hasIntegration = this.microsoftHintTarget.dataset.microsoftHasIntegration === "true"
      this.microsoftHintTarget.classList.toggle("hidden", !(value === "microsoft" && !hasIntegration))
    }
  }

  toggleOption() {
    this.optionTarget.value = this.menuTarget.classList.contains("hidden")
    this.toggle()
  }

  toggle() {
    console.log("toggle1")
    this.toggleTransition()
  }

  toggleEmail() {
    if (this.previewTarget.classList.contains("hidden")) {
      this.previewTarget.classList.remove("hidden")
      this.liTarget.classList.remove("hover:bg-gray-50")
      this.emailTarget.classList.add("hidden")
    } else {
      this.previewTarget.classList.add("hidden")
      this.liTarget.classList.add("hover:bg-gray-50")
      this.emailTarget.classList.remove("hidden")
    }
  }

  showField(div) {
    if (div.classList.contains("hidden")) {
      div.classList.remove("hidden")
    } else {
      div.classList.add("hidden")
    }
  }

  showCc() {
    const div = document.getElementById("mail_email_cc_div")
    this.showField(div)
  }

  showBcc() {
    const div = document.getElementById("mail_email_bcc_div")
    this.showField(div)
  }

  showMailbox() {
    const mailbox = document.getElementById("email_mailbox_id")
    const div = document.getElementById("mail_email_mailbox_div")

    this.showField(mailbox)
    this.showField(div)
  }

  changeMailbox() {
    // const mailbox = document.getElementById("email_mailbox_id")
    // console.log("change mailbox")
    // document.getElementById("mail_email_mailbox").textContent = mailbox.selectedOptions[0].textContent

    // const div = document.getElementById("mail_email_mailbox_div")
    // mailbox.classList.add("hidden")
    // div.classList.remove("hidden")

    // Dispatch a bubbling custom event
    const customEvent = new CustomEvent("intum-dropzone:mailbox-change", { bubbles: true })
    this.element.dispatchEvent(customEvent)
  }

  // generalnie pokazywanie zegara w JSie jest jakieś nieoczywiste i skomplikowane
  startTime() {
    const today = new Date(new Date().getTime() + this.clockOffset)
    this.clockTarget.innerHTML = today.toLocaleString()
    setTimeout(() => { this.startTime() }, "1000")
  }

  updateTimezone(event) {
    const timezone = event.target.value
    const url = this.clockTarget.dataset.url

    console.log(url)
    axios.get(url, {
      params: {
        timezone
      },
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    })
      .then(response => {
        console.log(response.data)
        if (response.data) {
          this.clockOffset = parseInt(response.data) - new Date().getTime()
        }
      })
      .catch(error => {
        console.log("error updating")
        console.warn(error)
      })
  }

  // zapisywanie wersji roboczej (chwilowo co 30 sekund)
  saveDraft() {
    // setTimeout(() => {
    //   Rails.fire(this.formTarget, 'submit')
    //   this.saveDraft()
    // }, "30000")
  }

  // Ustawia wartość hidden fielda commit przed wysłaniem formularza
  setCommit(event) {
    if (this.hasCommitTarget) {
      this.commitTarget.value = event.params.value
    }
  }

  disconnect() {
  }

  toggleHiddenEmails() {
    this.hiddenTarget.classList.remove("hidden")
    this.toggleTarget.classList.add("hidden")
  }

  // kopiowanie dla tekstu z komentarzy
  setupNoColorCopyHandler() {
    this.element.addEventListener("copy", function(event) {
      const selection = window.getSelection()
      if (!selection.rangeCount) return

      const range = selection.getRangeAt(0)
      const clonedContent = range.cloneContents()
      const div = document.createElement("div")
      div.appendChild(clonedContent)

      div.querySelectorAll("[style]").forEach(el => {
        el.style.background = ""
        el.style.backgroundColor = ""
        el.style.color = ""
      })

      event.preventDefault()
      event.clipboardData.setData("text/html", div.innerHTML)
      event.clipboardData.setData("text/plain", div.innerText)
    })
  }
}
